/**
 * Resolve the detail-page route for a saved / reviewer / place item.
 *
 * The EventDetail page lives at /event/:id and understands three id forms:
 *   - numeric            → an event
 *   - "review_<numeric>" → a review
 *   - "venue_<numeric>"  → a venue
 *
 * Items reach us in two shapes: raw saved rows (item_type + item_id) and
 * place-shaped rows (event_id / id + _source). This normalises either into the
 * right /event/:id path.
 */
export const resolveItemDetailPath = (item) => {
  if (!item) return null;

  const type = item.item_type || item._source || '';
  const rawCandidate =
    item.item_id != null ? String(item.item_id)
      : item.event_id != null ? String(item.event_id)
        : item.id != null ? String(item.id)
          : '';

  if (!rawCandidate) return null;

  const digits = rawCandidate.replace(/\D/g, '');
  const isReview = type === 'review' || rawCandidate.startsWith('review_');
  const isVenue = type === 'venue' || rawCandidate.startsWith('venue_');

  if (isReview) return digits ? `/event/review_${digits}` : null;
  if (isVenue) return digits ? `/event/venue_${digits}` : null;
  return digits ? `/event/${digits}` : `/event/${rawCandidate}`;
};

/**
 * Resolve a saved / place item into a { type, id } reference for fetching its
 * detail from the API (GET /events/:id, /reviews/:id, /venues/:id).
 */
export const resolveItemRef = (item) => {
  if (!item) return null;

  const type = item.item_type || item._source || '';
  const rawCandidate =
    item.item_id != null ? String(item.item_id)
      : item.event_id != null ? String(item.event_id)
        : item.id != null ? String(item.id)
          : '';

  if (!rawCandidate) return null;

  const digits = rawCandidate.replace(/\D/g, '');
  let t = 'event';
  if (type === 'review' || rawCandidate.startsWith('review_')) t = 'review';
  else if (type === 'venue' || rawCandidate.startsWith('venue_')) t = 'venue';

  return { type: t, id: digits || rawCandidate };
};

export default resolveItemDetailPath;
